import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";
import { useMutation } from "urql";

const RevokeApiKeyMutation = graphql(`
  mutation RevokeApiKey($input: RevokeApiKeyInput!) {
    revokeApiKey(input: $input)
  }
`);

export function useRevokeApiKey() {
  const [result, revokeApiKeyMutation] = useMutation(RevokeApiKeyMutation);
  const [error, setError] = useState<Error | null>(null);

  const revokeApiKey = useCallback(
    async (id: string) => {
      try {
        const response = await revokeApiKeyMutation({ input: { id } });
        if (response.error) {
          throw response.error;
        }
        return response.data?.revokeApiKey ?? false;
      } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error("Failed to revoke API key");
        console.error("unable to revoke api key", error);
        setError(error);

        return false;
      }
    },
    [revokeApiKeyMutation],
  );

  return { revokeApiKey, result, error };
}
